import { Link } from "react-router-dom";
import type { Article } from "@/types/article";
import { labelFor } from "@/v2/categories";
import { decodeEntities } from "@/v2/textUtils";

function formatTime(iso: string): string {
  try {
    const d = new Date(iso);
    const now = Date.now();
    const diffMin = Math.max(1, Math.round((now - d.getTime()) / 60000));
    if (diffMin < 60) return `${diffMin} min sedan`;
    const diffH = Math.round(diffMin / 60);
    if (diffH < 24) return `${diffH} tim sedan`;
    return d.toLocaleDateString("sv-SE", {
      day: "numeric",
      month: "short",
    });
  } catch {
    return "";
  }
}

export default function ArticleCard({ article }: { article: Article }) {
  const path = article.slug ? `/${article.category}/${article.slug}` : "#";
  const summary = decodeEntities(article.aiSummary || article.excerpt || "");
  const truncated =
    summary.length > 200 ? summary.slice(0, 197).trimEnd() + "…" : summary;
  const primaryUrl = article.sources?.[0]?.url ?? article.trendUrl;
  let faviconUrl: string | null = null;
  if (primaryUrl) {
    try {
      faviconUrl = `https://www.google.com/s2/favicons?domain=${new URL(primaryUrl).hostname}&sz=32`;
    } catch {
      /* ignore */
    }
  }

  return (
    <li className="k2-card">
      <h2 className="k2-card-title">
        <Link to={path}>{decodeEntities(article.title)}</Link>
      </h2>
      {truncated && <p className="k2-card-excerpt">{truncated}</p>}
      <div className="k2-meta">
        <span className="k2-cat-badge" data-cat={article.category}>
          {labelFor(article.category)}
        </span>
        {article.source && (
          <span className="k2-source">
            {faviconUrl && (
              <img
                src={faviconUrl}
                alt=""
                width={16}
                height={16}
                className="k2-favicon"
                loading="lazy"
              />
            )}
            {article.source}
          </span>
        )}
        {article.publishedAt && (
          <time dateTime={article.publishedAt}>
            {formatTime(article.publishedAt)}
          </time>
        )}
      </div>
    </li>
  );
}